/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import makeFormReadOnly from '@/util/makeFormReadOnly';
import { validateForm } from '@/util/ParsleyUtils';

import tmplSpecialtyRequirementDeviceEditModalView from './SpecialtyRequirementDeviceEditModalView.hbs';

const SpecialtyRequirementDeviceEditModalView = View.extend({
  template: tmplSpecialtyRequirementDeviceEditModalView,

  className: 'specialty-requirement-device-edit-modal-view',

  ui: {
    editSpecialtyRequirementDeviceForm: '.edit-specialty-requirement-device-form',
    submit: '.btn-submit',
    cancel: '.btn-cancel'
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
    'click @ui.cancel': 'onClickCancel'
  },

  onRender() {
    const model = this.model.get('device');
    Syphon.deserialize(this, model);
    if (this.model.get('isReadOnly')) {
      makeFormReadOnly(this.$el);
    }
  },

  async onClickSubmit(e) {
    e.preventDefault();
    const formData = Syphon.serialize(this.ui.editSpecialtyRequirementDeviceForm);
    try {
      await validateForm(this.ui.editSpecialtyRequirementDeviceForm);
      //call edit service here
      this.triggerMethod('modal:close', formData);
    } catch (err) {
      // ignore
    }
  },

  onClickCancel(e) {
    e.preventDefault();
    this.triggerMethod('modal:close');
  }
});

export default SpecialtyRequirementDeviceEditModalView;
